<template>
  <div class="gf_input-group">
    <div class="gf_input-label" v-if="isShowLabel">{{ txtLabel }}</div>
    <div class="gf_input-field" :class="{ focusing: isFocusing }">
      <input
        ref="field"
        class="gf_input-field__input"
        v-model="txtValue"
        v-focus="autofocus"
        :class="[
          {
            'gf_input-field__bolder': !hideBolder,
            'gf_input-field__input--clear': isShowClear,
          },
          inputClass,
        ]"
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete ? true : 'new-password'"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxLength"
        @mouseover="onHover"
        @mouseleave="onLeave"
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
        @keyup="onKeyup" />
      <div class="gf_input-field__clear" v-if="isShowClear">
        <i class="icon icon-deactivate" @click.stop="onClear"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    value: {
      type: String,
      default: '',
    },
    clear: {
      type: Boolean,
      default: true,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideBolder: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    maxLength: {
      type: [Number, Boolean],
      default: false,
    },
    txtLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value', 'clear', 'focus', 'blur', 'hover', 'leave', 'input', 'enter', 'keyup'],
  data() {
    return {
      txtValue: '',
      isFocusing: false,
    };
  },
  computed: {
    isShowClear() {
      return this.clear && this.txtValue && this.txtValue.length && !this.disabled
    },
    isShowLabel() {
      return this.txtLabel && this.txtLabel.length
    },
  },
  watch: {
    value(value) {
      this.txtValue = value;
    },
  },
  mounted() {
    this.txtValue = this.value;
  },
  methods: {
    setFocus(position) {
      this.$refs.field.focus();
      this.isFocusing = true;

      if (position) {
        window.setTimeout(() => {
          this.$refs.field.setSelectionRange(position, position);
        }, 0);
      }
    },

    getOffset() {
      if (this.$refs.field) {
        return this.$refs.field.getBoundingClientRect();
      }

      return {};
    },
    onClear() {
      this.$refs.field.focus();
      this.$emit('update:value', '');
      this.$emit('clear', '');
    },
    onFocus(e) {
      if (!this.disabled) {
        this.$emit('focus', e);
        this.isFocusing = true;
      }
    },
    onBlur(e) {
      this.$emit('blur', e);
      this.isFocusing = false;
    },
    onHover(e) {
      this.$emit('hover', e);
    },
    onLeave(e) {
      this.$emit('leave', e);
    },
    onInput() {
      this.$emit('update:value', this.txtValue);
    },
    onKeyup(event) {
      if (event.keyCode === 13) {
        this.$emit('enter', this.txtValue);
        return;
      }
      this.$emit('keyup', event);
    },
  },
};
</script>
<style lang="scss" scoped>
.gf_input {
  &-label {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: map-get($text-light-mode, "high-contrast");
    margin-bottom: 8px;
  }
  &-field {
    display: flex;
    align-self: flex-start;
    position: relative;
    width: 100%;
    transition: all 0.3s ease;
  
    &__input {
      display: flex;
      padding: 8px 7px;
      border-radius: 3px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: map-get($text-light-mode, "high-contrast");
      border: 1px solid map-get($hybrid-shade-light, "100");
      background-color: map-get($hybrid-shade-light, "100") !important;
      min-height: 24px;
      @include trans-all;
      &.gf_input-field__bolder {
        border: 1px solid map-get($hybrid-shade-light, "500");
      }
  
      &:hover {
        border-color: map-get($hybrid-shade-dark, "100");
      }
  
      &:focus {
        border-color: map-get($primary-blue, "300");
      }
  
      &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        color: map-get($text-light-mode, "disabled");
      }
      &--clear {
        padding-right: 39px;
      }
    }
  
    &__clear {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 14px;
      display: flex;
      padding: 5px;
      right: 16px;
      color: map-get($text-light-mode, "high-contrast");
      border-radius: 3px;
      .icon {
        height: fit-content;
        display: flex;
      }
      &:hover {
        background: #E5E5E5;
      }
    }
  }
}
</style>
